<template>
    <div class="">
        <div class="d-flex flex-column flex-xl-row flex-xl-nowrap align-items-xl-center justify-content-xl-between gap-3 mb-3 service-registers-page-header">
            <div class="flex-shrink-0 min-width-0">
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Registers</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Service Register</li>
                </ol>
                <h4 class="main-title mb-0">Service Registers</h4>
            </div>
            <div
                class="d-flex flex-column flex-lg-row flex-lg-wrap align-items-stretch align-items-lg-center justify-content-lg-end gap-2 service-registers-actions"
            >
                <div v-can="'service_registers.upload'" class="d-flex flex-wrap align-items-center gap-2">
                    <button type="button" class="btn btn-success" @click="downloadExcel">
                        <i class="ri-download-line"></i> Download Template
                    </button>
                    <button type="button" class="btn btn-warning text-dark" @click="downloadPendingOverdueExcel">
                        <i class="ri-alarm-warning-line"></i> Download Pending / Overdue
                    </button>
                </div>
                <div v-can="'service_registers.upload'" class="d-flex flex-wrap align-items-center gap-2 min-width-0 service-registers-upload">
                    <label for="uploadFile" class="btn btn-secondary mb-0 flex-shrink-0">
                        <i class="ri-file-line"></i> Choose File
                    </label>
                    <input type="file" id="uploadFile" ref="uploadFile" class="d-none" @change="onFileSelect" accept=".xlsx,.xls,.csv" />
                    <span
                        v-if="selectedFileName"
                        class="text-muted small text-truncate px-1 min-width-0 flex-grow-1 flex-lg-grow-0 service-registers-filename"
                        :title="selectedFileName"
                    >{{ truncatedFileName }}</span>
                    <button v-if="selectedFileName" type="button" class="btn btn-info flex-shrink-0" @click="uploadExcel">
                        <i class="ri-upload-line"></i> Upload
                    </button>
                </div>
                <router-link v-can="'service_registers.create'" to="/user_service/create" class="btn btn-primary flex-shrink-0 align-self-lg-center">
                    <i class="ri-list-check"></i> Add Service Register
                </router-link>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Service Registers</h6>
                    </div>
                    <div class="card-body">
                        <input class="form-control form-control-sm mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm text-nowrap table-striped table-bordered mb-0">
                                <thead>
                                    <tr class="" style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('service_no')">
                                            Service No.
                                            <span>
                                                <i v-if="meta.keyword == 'service_no' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'service_no' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('service_date')">
                                            Service Date
                                            <span>
                                                <i v-if="meta.keyword == 'service_date' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'service_date' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('service_cost')">
                                            Service Cost
                                            <span>
                                                <i v-if="meta.keyword == 'service_cost' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'service_cost' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('next_service_date')">
                                            Next Service Date
                                            <span>
                                                <i v-if="meta.keyword == 'next_service_date' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'next_service_date' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('service_name')">
                                            Service Name
                                            <span>
                                                <i v-if="meta.keyword == 'service_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'service_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('asset_code')">
                                            Asset Code
                                            <span>
                                                <i v-if="meta.keyword == 'asset_code' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'asset_code' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th>Created By</th>
                                        <th>Updated By</th>
                                        <!-- <th class="text-center" v-if="get_service.length">Actions</th> -->
                                        <th v-can="'service_registers.update' || 'service_registers.delete'" class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="service, key in user_services" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{service.service_no}}</td>
                                        <td>{{convertDateFormat(service.service_date)}}</td>
                                        <td>{{service.service_cost}}</td>
                                        <td>{{convertDateFormat(service.next_service_date)}}</td>
                                        <td>{{service.service?.service_name}}</td>
                                        <td>{{service.asset?.asset_code}}</td>
                                        <td>{{ service.user.name }}<br>{{ service.created_at }}</td>
                                        <td>
                                            <span v-if="service.updated_user_id!=null">{{ service.updated_user.name }}<br>{{ service.updated_at }}</span>
                                            <span v-else></span>
                                        </td>
                                        <!-- <td class="text-center" v-if="get_service.length">
                                            <a title="Edit" href="javascript:void(0)" class="text-success me-2" @click="editService(service)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                            <a title="View" href="javascript:void(0)" class="text-danger me-2" @click.prevent="deleteService(service)"><i class="ri-delete-bin-6-line fs-18 lh-1"></i></a>
                                        </td> -->
                                        <td class="text-center" v-can="'service_registers.update' || 'service_registers.delete'">
                                            <a v-can="'service_registers.update'" title="Edit" href="javascript:void(0)" class="text-success me-2" @click="editService(service)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                            <a v-can="'service_registers.delete'" title="View" href="javascript:void(0)" class="text-danger me-2" @click.prevent="deleteService(service)"><i class="ri-delete-bin-6-line fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                    <tr v-if="user_services.length==0">
                                        <td colspan="8" class="text-center">No records found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>
                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    import moment from "moment";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "desc",
                    keyword: "user_service_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                get_service: [],
                get_asset: [],
                user_services: [],
                errors: [],
                status: true,
                downloaded_excel: [],
                selectedFileName: '',
                selectedFile: null,
            };
        },
        computed: {
            truncatedFileName() {
                const name = this.selectedFileName;
                if (!name) {
                    return '';
                }
                const max = 40;
                return name.length > max ? name.slice(0, max) + '…' : name;
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if(!from.name == 'UserServices.Edit'){
                    vm.$store.commit("setCurrentPage", vm.meta.page)
                }else{
                    vm.meta.page = vm.$store.getters.current_page
                }
            });
        },
        mounted() {
            this.get_service = this.$store.getters.permissions.filter(function (element) {
                return element.ability.ability.includes("userServices.update") || element.ability.ability.includes("userServices.delete");
            });
            this.$store.commit("setAssetId", '');
            this.index();
            // sessionStorage.setItem('page', 1);
        },
        methods: {
            convertDateFormat(date) {
                let vm = this;
                return moment(date).format("yyyy-MM-DD");
            },
            index() {
                let vm = this;
                console.log("page", vm.meta.page)
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "paginateUserServices", data: vm.meta })
                    .then((response) => {
                        loader.hide();
                        vm.user_services = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.from = response.data.meta.from;
                        const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                        vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.page = response.data.meta.current_page;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            editService(service) {
                this.$store.commit("setCurrentPage", this.meta.page)
                this.$router.push("/user_service/" + service.user_service_id + "/edit");
            },
            deleteService(service) {
                const confirmDelete = confirm("Are you sure you want to delete it ?");
                if (confirmDelete) {
                    let vm = this;
                    let loader = vm.$loading.show();
                    vm.$store
                        .dispatch("post", {
                            uri: "deleteUserService",
                            data: service,
                        })
                        .then((response) => {
                            loader.hide();
                            vm.$store.dispatch("success", response.data.message);
                            vm.index();
                        })
                        .catch(function (error) {
                            loader.hide();
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            },
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            onPerPageChange() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            downloadExcel() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "downloadUserServices", data: vm.meta })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message || "Download started successfully.");
                        vm.downloaded_excel = response.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors ?? [];
                        vm.$store.dispatch("error", error.response?.data?.message || "Failed to download file.");
                    });
            },
            downloadPendingOverdueExcel() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "downloadPendingUserServices", data: vm.meta })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message || "Pending / overdue export started.");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors ?? [];
                        vm.$store.dispatch("error", error.response?.data?.message || "Failed to start export.");
                    });
            },
            onFileSelect(event) {
                let vm = this;
                const file = event.target.files[0];
                
                if (!file) {
                    vm.selectedFileName = '';
                    vm.selectedFile = null;
                    return;
                }

                // Validate file type
                const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
                const validExtensions = ['.xls', '.xlsx', '.csv'];
                const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
                
                if (!validTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
                    vm.$store.dispatch("error", "Please upload a valid Excel or CSV file.");
                    vm.$refs.uploadFile.value = '';
                    vm.selectedFileName = '';
                    vm.selectedFile = null;
                    return;
                }

                vm.selectedFileName = file.name;
                vm.selectedFile = file;
            },
            uploadExcel() {
                let vm = this;
                
                if (!vm.selectedFile) {
                    vm.$store.dispatch("error", "Please select a file first.");
                    return;
                }

                let loader = vm.$loading.show();
                let formData = new FormData();
                formData.append('file', vm.selectedFile);

                vm.$store
                    .dispatch("post", { uri: "uploadUserServices", data: formData })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message || "File uploaded successfully.");
                        vm.$refs.uploadFile.value = '';
                        vm.selectedFileName = '';
                        vm.selectedFile = null;
                        vm.index(); // Refresh the list
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors ?? [];
                        vm.$store.dispatch("error", error.response?.data?.message || "Failed to upload file.");
                        vm.$refs.uploadFile.value = '';
                        vm.selectedFileName = '';
                        vm.selectedFile = null;
                    });
            },
        },
    };
</script>
<style scoped>
.service-registers-page-header {
    width: 100%;
}
.service-registers-actions {
    min-width: 0;
    max-width: 100%;
}
@media (min-width: 1200px) {
    .service-registers-actions {
        max-width: min(100%, 58rem);
    }
}
.service-registers-upload {
    max-width: 100%;
}
.service-registers-filename {
    max-width: 14rem;
}
@media (min-width: 992px) {
    .service-registers-filename {
        max-width: 18rem;
    }
}
.min-width-0 {
    min-width: 0;
}
</style>
